import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { OnyxEvent } from '../models/event';
import { EventStore } from '../service/event.store';
import { Party } from '../models/party';

@Component({
  selector: 'pioneer-invoice-history-vendor',
  templateUrl: './invoice-history-vendor.component.html',
  styleUrls: ['./invoice-history-vendor.component.css']
})
export class InvoiceHistoryVendorComponent implements OnInit {

  public onyxEvent: OnyxEvent;

  eventSubscription$: Subscription = new Subscription();

  constructor(
    private eventStore: EventStore
  ) {
  }

  ngOnInit() {

    this.eventSubscription$ = this.eventStore.selectedEvent.subscribe((event: OnyxEvent) => {
      this.onyxEvent = new OnyxEvent(event);
    });

  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/invoice-history-vendor/invoice-history-vendor.component.ts